import type { Template } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";

export const sortTemplates = (templates: Template[]): Template[] => {
    return templates.sort((a, b) => (a.name!.localeCompare(b.name!) ? 1 : -1));
};
